import { render } from "./AnswerCard.vue?vue&type=template&id=6f0574e8"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__